export default "__VITE_ASSET__ae165309__"